// Single source of truth for the national online degree program's published
// cost figures. Every page, FAQ answer, and schema builder interpolates from
// here - do not hand-type these dollar amounts in page copy. A change to any
// figure lands everywhere at once (STX-662/664/673 each required the same
// edit across 8-10 files and still missed surfaces).
export const PROGRAM_COSTS = {
  registrationFee: 0,
  enrollmentDeposit: 20,
  fullTuition: 19520,
  // fullTuition + enrollmentDeposit
  total: 19540,
  // Flat rate for 7-12 credits per quarter
  quarterlyFlatRate: 2440,
  // Charged at 6 credits or fewer, and per credit above 12
  perCreditRate: 200,
  // Three quarters per academic year
  annualTuition: 7320,
  // All four quarters
  annualTuitionFourQuarters: 9760,
}

const usd = value => `$${value.toLocaleString('en-US')}`

// Preformatted display strings ('$19,520', '$2,440', ...)
export const COST = Object.fromEntries(
  Object.entries(PROGRAM_COSTS).map(([key, value]) => [key, usd(value)]),
)

// Published costs for the Sacramento healthcare certificate programs, read by
// each program page's Tuition and Fees table and by its schema offer in
// utils/seo/siteSchemas.js. total is enrollmentDeposit + tuition + books.
export const SACRAMENTO_PROGRAM_COSTS = {
  medicalAssistant: {
    enrollmentDeposit: 20,
    tuition: 8920,
    books: 0,
    total: 8940,
  },
  medicalAssistantWithPhlebotomy: {
    enrollmentDeposit: 20,
    tuition: 11760,
    books: 0,
    total: 11780,
  },
  medicalBillingAndCodingProfessional: {
    enrollmentDeposit: 20,
    tuition: 11360,
    books: 0,
    total: 11380,
  },
  medicalBillingAndCodingSpecialist: {
    enrollmentDeposit: 20,
    tuition: 9760,
    books: 0,
    total: 9780,
  },
  phlebotomy: {enrollmentDeposit: 20, tuition: 2840, books: 0, total: 2860},
}

// Preformatted display strings, keyed like SACRAMENTO_PROGRAM_COSTS
export const SACRAMENTO_COST = Object.fromEntries(
  Object.entries(SACRAMENTO_PROGRAM_COSTS).map(([program, costs]) => [
    program,
    Object.fromEntries(
      Object.entries(costs).map(([key, value]) => [key, usd(value)]),
    ),
  ]),
)
